import AvataUpload from "components/AvataUpload";
import {
  Button,
  Col,
  DatePicker,
  Form,
  FormInstance,
  Input,
  Modal,
  Row,
  Select,
  SelectProps,
  Space,
  Spin,
  Typography,
} from "antd";
import React, { FC, useEffect, useState } from "react";
import styled from "@emotion/styled";
import locale from "antd/es/date-picker/locale/th_TH";
import { EditOutlined } from "@ant-design/icons";
import { useGetAllCategory } from "hooks/useCategory";
import { AddressFacData, CategoryResponse, MasterRetailTypeData } from "services/interface";
import SettingAvatar from "./SettingAvatar";
import FactoryAddress from "./FactoryAddress";
import MapGoogle from "components/GoogleMap";
import { useGetFactoryDataNonAuthen } from "hooks/useFactory";
import { useGetRetailType } from "hooks/useMasterData";

const { Option } = Select;

const { Text } = Typography;

type Location = {
  lat: number;
  lng: number;
}

const factory_type = [
  {
    value: "hospital",
    label: "โรงพยาบาล"
  },
  {
    value: "clinic",
    label: "คลินิก"
  }
]

interface SettingFactoryFormProps {
  form: FormInstance;
  onFinish: (values: any) => void;
  avatar: any;
  address_fac: AddressFacData | undefined;
  location: Location;
  setLocation: (location: Location) => void;
}

const SettingFactoryForm: FC<SettingFactoryFormProps> = ({
  form,
  onFinish,
  avatar,
  address_fac,
  location,
  setLocation,
}) => {
  const [category, setCategory] = useState<CategoryResponse>([]);

  const { data, isLoading } = useGetAllCategory();

  const { data: dataFactory, isLoading: isLoadingFactory } = useGetFactoryDataNonAuthen();

  const { data: dataRetailType, isLoading: reatilTypeLoading } = useGetRetailType()

  const [retailType, setRetailType] = useState<MasterRetailTypeData[]>([]);

  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (data) {
      setCategory(data);
    }
  }, [data]);

  const children: React.ReactNode[] = [];
  const childrenFactory: React.ReactNode[] = [];

  category.forEach((item) => {
    //children.push(<Option key={item.id}>{item.name}</Option>);
    if (item.childrens) {
      children.push(
        <Option key={item.id} value={item.id}>
          {item.name}
        </Option>
      );
      item.childrens.forEach((child) => {
        children.push(
          <Option key={child.id} value={child.id}>
            {child.name}
          </Option>
        );
        if (child.childrens) {
          child.childrens.forEach((child) => {
            children.push(
              <Option key={child.id} value={child.id}>
                {child.name}
              </Option>
            );
          });
        }
      });
    } else {
      children.push(
        <Option key={item.id} value={item.id}>
          {item.name}
        </Option>
      );
    }
  });

  dataFactory?.data.forEach((item) => {
    childrenFactory.push(
      <Option key={item.id} value={item.id}>
        {item.name}
      </Option>
    );
  });

  const options: SelectProps['options'] = [];

  for (let i = 0; i < retailType.length; i++) {
    options.push({
      value: retailType[i].id,
      label: retailType[i].description,
      key: retailType[i].id,
      id: retailType[i].id,
    });
  }

  useEffect(() => {
    if (dataRetailType) {
      setRetailType(dataRetailType.data);
    }
  }, [dataRetailType]);

  return (
    <>
      {/* <WrapperAvata>
        <AvataUpload value={avatar} maximumUploadItems={1} />
      </WrapperAvata> */}
      <Form
        form={form}
        onFinish={onFinish}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 24 }}
      >
        <Row justify={"center"}>
          <SettingAvatar />
        </Row>
        <Row justify={"center"} style={{ marginBottom: 20 }}>
          <Typography.Text>รูปโรงพยาบาล</Typography.Text>
        </Row>

        <Form.Item
          name="name"
          labelAlign="left"
          label="ชื่อโรงพยาบาล"
          rules={[{ required: true, message: "กรุณากรอกชื่อโรงพยาบาล" }]}
        >
          <Input />
        </Form.Item>

        { /* ภายใต้โรงพยาบาล  */}
        <Form.Item
          label='ภายใต้โรงพยาบาล'
          name='parent_id'
          labelAlign="left"
        // rules={[{ required: true, message: 'กรุณาเลือกโรงพยาบาล' }]}
        >
          <Select
            showSearch
            placeholder='ภายใต้โรงพยาบาล'
            optionFilterProp='children'
            notFoundContent={isLoadingFactory ? <Spin size='small' /> : null}
            loading={isLoadingFactory}
            allowClear
          >
            {childrenFactory}
          </Select>
        </Form.Item>

        <Form.Item
        label='ประเภทโรงพยาบาล'
        name='factory_type'
        labelAlign="left"
        rules={[{ required: true, message: 'กรุณาเลือกประเภทโรงพยาบาล' }]}
      >
        <Select
          showSearch
          placeholder='ประเภทโรงพยาบาล'
          optionFilterProp='children'
          notFoundContent={isLoading ? <Spin size='small' /> : null}
          loading={isLoading}
        >
          {factory_type.map((item) => (
            <Option key={item.value} id={item.value}>
              {item.label}
            </Option>
          ))}
        </Select>
      </Form.Item>


        {/* <Form.Item
          name="category"
          labelAlign="left"
          label="หมวดหมู่สินค้าที่ขาย"
          rules={[{ required: true, message: "กรุณากรอกหมวดหมู่สินค้าที่ขาย" }]}
        >
          <Select
            showSearch
            placeholder="หมวดหมู่สินค้าที่ขาย"
            optionFilterProp="children"
            notFoundContent={isLoading ? <Spin size="small" /> : null}
            loading={isLoading}
          >
            {children}
          </Select>
        </Form.Item> */}

        <Form.Item
        label='แผนก'
        name='retail_type'
        rules={[{ required: true, message: 'กรุณาเลือกแผนก' }]}
        labelAlign="left"
      >
        <Select
          mode='multiple'
          showSearch
          placeholder='แผนก'
          optionFilterProp='childrenRetailType'
          notFoundContent={isLoading ? <Spin size='small' /> : null}
          loading={isLoading}
         // onChange={value => console.log(value)}
          options={options}
        >
        </Select>
      </Form.Item>

        {/* <Form.Item
          name="address"
          labelAlign="left"
          label="ที่อยู่โรงพยาบาล"
          rules={[{ required: true, message: "กรุณากรอกที่อยู่" }]}
        >
          <Input
            disabled={true}
            // onChange={(e) => {}}
            suffix={
              <>
                <Button
                  type="link"
                  icon={<EditOutlined size={24} />}
                  size="middle"
                  style={{ marginLeft: "25%" }}
                  onClick={showDrawer}
                ></Button>
              </>
            }
          />
        </Form.Item> */}

        <FactoryAddress form={form} address_fac={address_fac} />

        {/* <Form.Item name="location" labelAlign="left" label="ที่ตั้งโรงพยาบาล">
          <MapGoogle location={location} setLocation={setLocation} />
        </Form.Item> */}

        <Form.Item>
          <WrapperButton>
            <Button
              style={{ width: 250 }}
              type="primary"
              size="large"
              htmlType="submit"
            >
              บันทึก
            </Button>
          </WrapperButton>
        </Form.Item>
      </Form>
    </>
  );
};

export default SettingFactoryForm;

const WrapperAvata = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 40px;
  width: 130px;
  height: auto;
  margin-left: auto;
  margin-right: auto;
`;

const WrapperButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 100%;
`;
